const PROJECT_MEASUREMENT_LIST = 'ProjectMeasurementList';
const PROJECT_MEASUREMENT_BASIC_INFO = 'ProjectMeasurementBasicInfo';
const PROJECT_MEASUREMENT_ADD_MEASUREMENT = 'ProjectMeasurementAddMeasurement';

export {
  PROJECT_MEASUREMENT_LIST,
  PROJECT_MEASUREMENT_BASIC_INFO,
  PROJECT_MEASUREMENT_ADD_MEASUREMENT,
};
